import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const iconBoxVariants = cva(
  'flex items-center justify-center shrink-0',
  {
    variants: {
      size: {
        sm: 'w-7 h-7',
        md: 'w-9 h-9',
        lg: 'w-10 h-10',
        xl: 'w-16 h-16',
        '2xl': 'w-20 h-20',
      },
      radius: {
        md: 'rounded-md',
        lg: 'rounded-lg',
        xl: 'rounded-xl',
        '2xl': 'rounded-2xl',
        full: 'rounded-full',
      },
      variant: {
        muted: 'bg-primary/10 text-primary',
        solid: 'bg-primary text-primary-foreground',
        ghost: 'bg-muted text-muted-foreground',
      },
    },
    defaultVariants: {
      size: 'md',
      radius: 'md',
      variant: 'muted',
    },
  }
);

interface IconBoxProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof iconBoxVariants> {}

const IconBox = React.forwardRef<HTMLDivElement, IconBoxProps>(
  ({ className, size, radius, variant, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(iconBoxVariants({ size, radius, variant }), className)}
      {...props}
    />
  )
);
IconBox.displayName = 'IconBox';

export { IconBox, iconBoxVariants };
